<template>
  <div class="reset-wrapper">
    <div
      class="reset-background"
      :style="{
        backgroundImage: background
          ? `url(${background})`
          : 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      }"
    >
      <div class="reset-overlay"></div>
    </div>

    <div id="particles-js-reset" class="particles-container"></div>

    <div class="reset-card">
      <h1 class="reset-title">Restablecer contraseña</h1>
      <p class="reset-subtitle">
        Ingresa tu nueva contraseña y confírmala para actualizar el acceso.
      </p>

      <form @submit.prevent="submit" class="reset-form">
        <label for="new-password" class="field-label">Nueva contraseña</label>
        <input
          id="new-password"
          v-model="password"
          type="password"
          class="field-input"
          minlength="6"
          required
          autocomplete="new-password"
        />

        <label for="confirm-password" class="field-label"
          >Repetir nueva contraseña</label
        >
        <input
          id="confirm-password"
          v-model="passwordConfirmation"
          type="password"
          class="field-input"
          minlength="6"
          required
          autocomplete="new-password"
        />

        <p v-if="error" class="error-message">{{ error }}</p>
        <p v-if="success" class="success-message">{{ success }}</p>

        <button type="submit" class="submit-button" :disabled="loading">
          {{ loading ? "Actualizando..." : "Guardar nueva contraseña" }}
        </button>

        <button type="button" class="back-button" @click="goToLogin">
          Volver al inicio de sesión
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import "particles.js";

export default {
  name: "ResetPassword",
  data() {
    return {
      password: "",
      passwordConfirmation: "",
      loading: false,
      error: "",
      success: "",
    };
  },
  computed: {
    resetPasswordToken() {
      return String(this.$route.query?.reset_password_token || "").trim();
    },
    background() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.login_background
        : null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initParticles();
    });
  },
  beforeDestroy() {
    if (window.pJSDom && window.pJSDom.length > 0) {
      const target = window.pJSDom.find(
        (instance) => instance?.pJS?.canvas?.el?.id === "particles-js-reset"
      );
      if (target) {
        target.pJS.fn.vendors.destroypJS();
        window.pJSDom = window.pJSDom.filter((instance) => instance !== target);
      }
    }
  },
  methods: {
    initParticles() {
      if (window.particlesJS) {
        window.particlesJS("particles-js-reset", {
          particles: {
            number: {
              value: 25,
              density: {
                enable: true,
                value_area: 1000,
              },
            },
            color: {
              value: "#ffffff",
            },
            shape: {
              type: "circle",
            },
            opacity: {
              value: 0.25,
              random: true,
              anim: {
                enable: true,
                speed: 0.3,
                opacity_min: 0.1,
                sync: false,
              },
            },
            size: {
              value: 2,
              random: true,
              anim: {
                enable: false,
              },
            },
            line_linked: {
              enable: false,
            },
            move: {
              enable: true,
              speed: 0.3,
              direction: "none",
              random: true,
              straight: false,
              out_mode: "out",
              bounce: false,
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "repulse",
              },
              onclick: {
                enable: false,
              },
              resize: true,
            },
            modes: {
              repulse: {
                distance: 80,
                duration: 0.4,
              },
            },
          },
          retina_detect: true,
        });
      }
    },
    goToLogin() {
      this.$router.push({
        name: "login",
        params: { customer: this.$route.params.customer },
      });
    },
    async submit() {
      this.error = "";
      this.success = "";

      if (!this.resetPasswordToken) {
        this.error = "El enlace de recuperación es inválido o expiró.";
        return;
      }

      if (this.password !== this.passwordConfirmation) {
        this.error = "Las contraseñas no coinciden.";
        return;
      }

      this.loading = true;

      try {
        await this.axios.put("auth/password", {
          password: this.password,
          password_confirmation: this.passwordConfirmation,
          reset_password_token: this.resetPasswordToken,
        });

        this.success = "Contraseña actualizada. Ya puedes iniciar sesión.";
      } catch (e) {
        this.error =
          e?.response?.data?.errors?.[0] ||
          e?.response?.data?.error ||
          "No se pudo actualizar la contraseña.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.reset-wrapper {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.reset-background {
  position: fixed;
  inset: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.reset-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(10, 22, 40, 0.75) 0%,
    rgba(26, 26, 46, 0.65) 50%,
    rgba(22, 33, 62, 0.75) 100%
  );
}

.particles-container {
  position: fixed;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}

.reset-card {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 480px;
  padding: 30px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
}

.reset-title {
  margin: 0;
  color: #1f2937;
  font-size: 1.5rem;
}

.reset-subtitle {
  margin: 10px 0 18px;
  color: #6b7280;
}

.reset-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.field-label {
  color: #374151;
  font-size: 0.88rem;
  font-weight: 600;
}

.field-input {
  height: 46px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 0 12px;
  color: #1f2937;
}

.field-input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  outline: none;
}

.error-message {
  margin: 0;
  color: #dc2626;
  font-size: 0.87rem;
}

.success-message {
  margin: 0;
  color: #059669;
  font-size: 0.87rem;
}

.submit-button {
  height: 46px;
  margin-top: 4px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.back-button {
  height: 42px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: #4b5563;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
}
</style>
